export type TriggerReconcilerRpcMethod =
  | 'catalog.TriggerReconciler'
  | 'events.TriggerReconciler'
  | 'account_baseline.TriggerReconciler';

/**
 * Resolves which RPC namespace owns TriggerReconciler for a Kernel-listed reconciler,
 * or null when that reconciler exposes no trigger RPC. Single source for the Kernel
 * surface's resolvability check (opsService.triggerReconciler + KernelModal.canTriggerReconciler),
 * which previously hand-copied this logic in two places.
 */
export function resolveTriggerReconcilerRpc(domainType: string): TriggerReconcilerRpcMethod | null {
  if (domainType.startsWith('sc-')) {
    return 'catalog.TriggerReconciler';
  }
  if (domainType === 'rules') {
    return 'events.TriggerReconciler';
  }
  // The account baseline has its own context and Lambda, so its own trigger.
  if (domainType === 'aws-account-baseline') {
    return 'account_baseline.TriggerReconciler';
  }
  return null;
}
